import debounce from "~/directives/debounce/index";

// orlando标注：参考tooltips写的，可能不需要这个
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("debounce", debounce);
});
